/* eslint-disable react/jsx-key */

export default [
    ['PC', 'PC'],
    ['MOBILE', '移动端'],
    ['PAD', 'PAD'],
]
